import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";

const FETCH_ONE_DRIVE_ITEM = gql`
  query FETCH_ONE_DRIVE_PRODUCTS($oneDriveFolderId: String!) {
    oneDriveItem(id: $oneDriveFolderId)
  }
`;

const ChooseFolderImagesView = ({ oneDriveFolderId, value, onClick }) => {
  const { loading, error, data } = useQuery(FETCH_ONE_DRIVE_ITEM, {
    variables: { oneDriveFolderId },
  });

  if (loading)
    return (
      <div className="relative">
        <InlineSpinner text={null} size={21} />
      </div>
    );
  if (error) return <Errors error={error} />;

  const oneDriveImages = JSON.parse(data.oneDriveItem)
    .value.filter(
      (i) =>
        i.file.mimeType === "image/jpeg" || i.file.mimeType === "image/png",
    )
    .map((i) => ({
      ...i,
      selected: value.includes(i.id),
    }));

  return (
    <div>
      <div className="grid grid-cols-8 gap-6 mt-3">
        {oneDriveImages.map((i) => (
          <div
            key={i.id}
            className="flex flex-col items-center cursor-pointer"
            onClick={() => onClick(i.id)}
          >
            <div
              className={`border-4 ${i.selected ? "border-green-600" : "border-transparent"}`}
            >
              {i.thumbnails.length > 0 ? (
                <img src={i.thumbnails[0].large.url} alt={i.name} />
              ) : (
                <div className="w-32 h-32 bg-gray-200 flex items-center justify-center">
                  No Image Available
                </div>
              )}
            </div>
            <div className="text-xs mt-1 break-all whitespace-pre-wrap text-center p-3">
              {i.name}
            </div>
          </div>
        ))}
      </div>
      <div className=" opacity-70 text-xs">
        Only jpeg and png images are supported. If you want to use other
        formats, please convert them to jpeg or png first.
      </div>
    </div>
  );
};

export default ChooseFolderImagesView;
